<template>
  <footer>
    <div class="content legal">
      <p class="align-center">&copy;2018 Advantage Truck Group All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script>
  export default {
    name:'Footer',
    data(){
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue